import { stage } from 'root/src/aws/util/resourcePrefix'
import { awsHostedZoneId, AWS_STACK_DOMAIN } from 'root/config/stackConfig'
import { isProdEnv } from 'root/src/shared/util/envSelect'

export const apexDomain = isProdEnv ? 'daredrop.com' : AWS_STACK_DOMAIN ?? process.env.AWS_STACK_DOMAIN
export const hostedZoneId = isProdEnv ? 'Z10DS6P5G65S82' : awsHostedZoneId
export default isProdEnv ? apexDomain : `${stage.toLowerCase()}.${apexDomain}`
